import * as Animate from "react-reveal";
import { ArrowUpRight } from "../../../components/svgs";

const principles = [
  {
    number: "01",
    title: "Hit heavy, stay small",
    desc:
      "Tightly knit, dynamic teams work with more agility, communication and freedom than large-scale companies.",
  },
  {
    number: "02",
    title: "Ambition by the boatload",
    desc:
      "We love people who aim for greatness. They inspire their teammates and raise the bar for all of us.",
  },
  {
    number: "03",
    title: "Open communication",
    desc:
      "We value transparency because it makes communication easier, clearer and more useful.",
  },
  {
    number: "04",
    title: "Autonomy and attitude",
    desc:
      "We are a team of self-starters who take serious pride in the work and the people it serves.",
  },
  {
    number: "05",
    title: "Support and win",
    desc: "When we empower others to succeed, we all move forward together.",
  },
  {
    number: "06",
    title: "Teamwork makes the dream work",
    desc:
      "We bring different passions and expertise together to make Utiva the best it can be.",
  },
];

const AboutCultureSection = () => {
  return (
    <section className="bg-primary py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center font-poppins gap-3 text-secondary text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                The Utiva culture
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight text-white font-poppins font-black mb-5 tracking-[-0.03em]">
                How we work shapes the impact we make.
              </h2>
              <p className="text-indigo-100 text-base font-poppins leading-relaxed mb-8">
                Our culture is practical, ambitious and deeply collaborative.
                These principles help us move quickly without forgetting who the
                work is for.
              </p>
              <a
                href="/careers"
                className="bg-secondary text-primary font-poppins font-extrabold rounded-xl inline-flex items-center gap-3 px-5 py-4 custom-btn"
              >
                Explore careers <ArrowUpRight className="w-3.5 h-3.5" />
              </a>
            </div>
          </Animate.Fade>

          <div className="grid gap-0 border-t border-white/15">
            {principles.map((item) => (
              <Animate.Fade bottom key={item.number}>
                <div
                  className="grid gap-4 py-6 border-b border-white/15"
                  style={{ gridTemplateColumns: "38px 1fr" }}
                >
                  <span className="text-secondary font-poppins text-xs font-extrabold">
                    {item.number}
                  </span>
                  <div>
                    <h3 className="font-poppins font-bold text-lg text-white mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-indigo-100 font-poppins text-sm leading-relaxed m-0">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </Animate.Fade>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCultureSection;
